import { useAuthenticatedApiClient } from '@guiker/react-framework'
import { AdminApiClient } from '@guiker/tenant-preference-shared'

export const useAdminTenantPreferenceApiClient = useAuthenticatedApiClient(AdminApiClient)
